export default __webpack_public_path__ + "static/media/Group 4406.df2c1ac3.svg";